<ng-container *ngIf="state$ | async; let state">
    <div class="zas-row">
        <div class="zas-main-col">
            <span>Sie wünschen eine Beratung zu folgenden Produkten: </span>
            <zbd-info style="display: inline-block">
                Die Auswahl der Produkte, zu denen eine Beratung stattgefunden
                hat, kann im Abschnitt "Produktauswahl" geändert werden.
            </zbd-info>
            <ul>
                <li *ngFor="let category of getProductList(state.protocol)">
                    {{ category.category }}
                    <ul>
                        <li *ngFor="let product of category.products">
                            {{ product }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</ng-container>
